import React, { useState } from 'react';
import { privateRoot } from 'routes/paths';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import TitlePage from 'components/TituloPage';
import Filtro from 'containers/Relatorios/filtro';
import RelatorioPerformanceAtendenteResumido from 'containers/Relatorios/relatorioResumido/performanceAtendenteResumido';
import RelatorioDetalhadaPerformance from 'containers/Relatorios/relatorioDetalhado/tabelaRelDetalhadaPerformance';
import { fetchGetRelatorioGrafico } from 'store/fetchActions/fetchRelatorios';
import { fetchGetTodosAtendentesGeral } from 'store/fetchActions/fetchAtendente';
import { ENUM_TIPO_RELATORIO } from 'utils/consts';
import { montaNomeAtendente, montarDadosInputSelect } from 'utils/funcaoPadrao';
import * as S from './styles';
import * as Style from 'components/Style';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';
import { fetchBuscarSetores } from 'store/fetchActions/fetchSetores';

export default function PageRelatorioPerformanceAtendente() {
  const tipoRelatorio = ENUM_TIPO_RELATORIO.ATENDIMENTOS;

  const dispatch = useDispatch();
  const { isSetorial } = useParams();

  const user = useSelector(state => state.sefaz.userProfile);
  const inputSelectOptionsSetores = useSelector(state => state.inputs.inputSelectOptionsSetores);

  const [filtroSelecionado, setFiltroSelecionado] = useState({});
  const [dadosGrafico, setDadosGrafico] = useState(null);
  const [dadosGrid, setDadosGrid] = useState(null);
  const [todosAtendentes, setTodosAtendentes] = useState([]);

  React.useEffect(() => {
    if (user?.profile === ENUM_TIPO_PERFIL.SUPERVISOR_SETORIAL) dispatch(fetchBuscarSetores(false));
    dispatch(fetchGetTodosAtendentesGeral()).then(resposta => {
      const tipoFiltroSetorial = isSetorial ? true : false;
      let atendentesExibir = resposta.filter(x => x.isSetorial === tipoFiltroSetorial);
      setTodosAtendentes(
        atendentesExibir?.map(atendente => {
          return {
            value: atendente?.id,
            label: montaNomeAtendente(atendente?.nome),
          };
        })
      );
    });
  }, [dispatch, user, isSetorial]);

  const pesquisarDados = filtro => {
    setDadosGrid(null);
    dispatch(fetchGetRelatorioGrafico(filtro))
      .then(res => setDadosGrafico(res))
      .catch(() => setDadosGrafico(null));
  };

  const clearDados = () => {
    setDadosGrafico(null);
  };

  const pesquisarDadosGridSolicitacao = () => {
    dispatch(fetchGetRelatorioGrafico({ ...filtroSelecionado, TabelaSolicitacao: true })).then(res =>
      setDadosGrid(res.periodo)
    );
  };

  return (
    <S.Page>
      <TitlePage
        textTitle={`Relatório de Performance por Atendente ${isSetorial ? 'Setorial' : ''}`}
        backPage={privateRoot}
      />
      <Filtro
        salvarFiltro={setFiltroSelecionado}
        funcPesquisar={pesquisarDados}
        tipoRelatorio={tipoRelatorio}
        cleanDadosGrafico={clearDados}
        dadosGrafico={dadosGrafico}
        filtro={filtroSelecionado}
        relatorioNome={'Relatorio_Performance_Por_Atendente'}
        showInputAtendente={true}
        todosAtendentes={todosAtendentes}
        isPesquisaAtendenteSetorial={isSetorial}
        showInputSetor={user?.profile === ENUM_TIPO_PERFIL.SUPERVISOR_SETORIAL}
        todosSetores={montarDadosInputSelect(inputSelectOptionsSetores, 'id', 'nome')}
      />

      <Style.GlobalCard>
        <S.Descricao>
          <h2>{`Relatório de Performance por Atendente ${isSetorial ? 'Setorial' : ''}`}</h2>
          Cada requerimento pode ter um status por vez, esse status mostra em qual processo o requerimento está no
          momento. Os status são:&nbsp;
          <br />O gráfico mostra a quantidade em porcentagem de requerimentos por status no período selecionado, para
          visualizar ou exportar os dados clique no botão preencha o filtro.
        </S.Descricao>
        <RelatorioPerformanceAtendenteResumido
          isSetorial={isSetorial}
          dadosGrafico={dadosGrafico}
          filtroSelecionado={filtroSelecionado}
        />
        <RelatorioDetalhadaPerformance
          dadosGrid={dadosGrid}
          mostrarDados={pesquisarDadosGridSolicitacao}
          dadosGrafico={dadosGrafico}
        />
      </Style.GlobalCard>
    </S.Page>
  );
}
